<template>
  <div class="interview h-100">
    <div class="mx-lg-2">
      <loading v-if="!interview"></loading>
      <div v-if="interview && interview.current_question">
        <div
          v-if="interview.current_question.answer_options_type === 'symptom'"
        >
          <div v-if="symptomOptions">
            <symptoms-form
              :text="interview.current_question.text"
              :gender="interview.patient_gender"
              :age="interview.patient_age_in_months"
              :value="symptomOptions"
              :language="$i18n.locale"
              :nextCallback="next"
            ></symptoms-form>
          </div>
        </div>
        <div v-else>
          <component
            :is="componentName(interview.current_question.answer_type)"
            :question="interview.current_question"
            :nextCallback="next"
          ></component>
        </div>
      </div>
      <div v-else-if="interview && interview.status === 'finished'" class="m-3">
        <triage v-if="interview.triage" :triage="interview.triage"></triage>
        <conditions
          :conditions="interview.conditions"
          :interview-id="interview.id"
          :schedule-id="interview.schedule_id"
        ></conditions>
        <evidences :evidences="interview.evidences"></evidences>
        <!-- <labtests
          :labtests="interview.obligatory_labtests"
          text="requiredLabs"
        ></labtests>
        <labtests
          :labtests="interview.recommended_labtests"
          text="recomendedLabs"
        ></labtests> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import SymptomsForm from "@/components/SymptomChecker/SymptomsForm";
import Multiple from "@/components/SymptomChecker/Multiple";
import Single from "@/components/SymptomChecker/Single";
import MultipleComplex from "@/components/SymptomChecker/MultipleComplex";
import Triage from "@/components/SymptomChecker/Triage";
import Conditions from "@/components/SymptomChecker/Conditions";
import Evidences from "@/components/SymptomChecker/Evidences";
// import Labtests from '@/components/SymptomChecker/Labtests'
import Loading from "@/components/Loadings/Message";

export default {
  components: {
    Loading,
    SymptomsForm,
    Triage,
    Conditions,
    Evidences,
    Single,
    Multiple,
    MultipleComplex
  },
  props: {
    interviewId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      interview: null,
      keyword: null,
      symptoms: [],
      selectedSymptoms: [],
      isLoading: false,
      symptomTimeout: null
    };
  },
  computed: {
    ...mapGetters({
      authUser: "auth/user",
      labtestById: "labtest/byId"
    }),
    symptomOptions() {
      const symptoms = [];
      for (const s of this.symptoms) {
        symptoms.push({
          id: s.id,
          name: s.name.ka
        });
      }
      return symptoms;
    }
  },
  mounted() {
    this.fetch(this.interviewId);
    this.$cookie.set("interview", this.interviewId, 60 * 20);
  },
  methods: {
    ...mapMutations({
      setError: "alert/setError"
    }),
    componentName(val) {
      switch (val) {
        case "single":
          return "single";
        case "multiple":
          return "multiple";
        case "multiple_complex":
          return "multiple-complex";
      }
    },
    next(values) {
      const answers = [];
      const question = this.interview.current_question;
      if (question.answer_options_type === "symptom") {
        for (const v of values) {
          answers.push(v.id);
        }
      } else {
        for (const v of values) {
          answers.push(v);
        }
      }
      if (answers.length > 0) {
        this.setAnswers(answers);
      }
    },
    async setAnswers(answers) {
      const id = this.interview.id;
      let url = `/guest/interviews/${id}/answer-question`;
      if (this.authUser) {
        url = `/api/interviews/${id}/answer-question`;
      }
      try {
        this.interview = null;
        const response = await this.axios.post(url, { answers: answers });
        this.interview = response.data.data;
      } catch (err) {
        this.setError(err);
      }
    },
    async fetch(id) {
      if (!id) return;
      let url = `/guest/interviews/${id}`;
      if (this.authUser) {
        url = `/api/interviews/${id}`;
      }
      try {
        const response = await this.axios.get(url);
        this.interview = response.data.data;
        if (this.interview.status === "initiated") {
          this.fetchActivate(id);
        }
      } catch (err) {
        this.setError(err);
      }
    },
    async fetchActivate(id) {
      if (!id) return;
      let url = `/guest/interviews/${id}/activate`;
      if (this.authUser) {
        url = `/api/interviews/${id}/activate`;
      }
      try {
        const response = await this.axios.post(url);
        this.interview = response.data.data;
      } catch (err) {
        this.setError(err);
      }
    },
    async fetchSymptoms(keyword) {
      this.isLoading = true;
      if (!keyword) {
        this.isLoading = false;
        return;
      }
      clearTimeout(this.symptomTimeout);
      this.symptomTimeout = setTimeout(async () => {
        try {
          const params = {
            language: this.interview.language,
            keyword: keyword,
            age: this.interview.patient_age_in_months,
            gender: this.interview.patient_gender
          };
          const response = await this.axios.get("/api/search/symptoms", {
            params
          });
          this.symptoms = response.data.data;
          this.isLoading = false;
        } catch (err) {
          this.setError(err);
          this.isLoading = false;
        }
      }, 500);
    }
  }
};
</script>
<style lang="scss">
.interview {
  button {
    svg {
      width: 24px;
    }
  }
  .table {
    svg {
      width: 16px;
    }
  }
}
</style>
